import { memo } from "react";
import { Progress } from "@/components/ui/progress";

interface StatCardProps {
  title: string;
  value: string;
  icon: string;
  iconBgColor: string;
  iconColor: string;
  progressColor: string;
  progressValue: number;
  subtext: string;
}

const StatCard = memo(function StatCard({
  title,
  value,
  icon,
  iconBgColor,
  iconColor,
  progressColor,
  progressValue,
  subtext
}: StatCardProps) {
  return (
    <div className="bg-white p-5 sm:p-6 rounded-2xl shadow-sm border border-neutral-200 hover:shadow-md transition-shadow duration-200">
      <div className="flex flex-col sm:flex-row sm:items-center space-y-3 sm:space-y-0 sm:space-x-4">
        <div className={`w-12 h-12 rounded-full ${iconBgColor} ${iconColor} flex items-center justify-center flex-shrink-0`}>
          <i className={`${icon} text-lg`}></i>
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-sm font-medium text-neutral-500">{title}</p>
          <h3 className="text-xl font-semibold text-neutral-800">{value}</h3>
        </div>
      </div>
    <div className="mt-3 sm:mt-4">
      <Progress value={progressValue} className={`${progressColor} h-1.5 sm:h-2`} />
      <p className="text-xs text-neutral-500 mt-1 sm:mt-2 leading-tight line-clamp-2">{subtext}</p>
    </div>
    </div>
  );
});

export default StatCard;
